module.exports = __webpack_public_path__ + "static/img/4_2.5ad2d773.jpg";